__turbopack_context__.v({
  "clearwaterFl33762": "form-block-module-scss-module__GkB92a__clearwaterFl33762",
  "contacts": "form-block-module-scss-module__GkB92a__contacts",
  "container": "form-block-module-scss-module__GkB92a__container",
  "cta": "form-block-module-scss-module__GkB92a__cta",
  "descriptor": "form-block-module-scss-module__GkB92a__descriptor",
  "emailLink": "form-block-module-scss-module__GkB92a__emailLink",
  "fairchildDr": "form-block-module-scss-module__GkB92a__fairchildDr",
  "formblock": "form-block-module-scss-module__GkB92a__formblock",
  "icon": "form-block-module-scss-module__GkB92a__icon",
  "iconBox2": "form-block-module-scss-module__GkB92a__iconBox2",
  "info": "form-block-module-scss-module__GkB92a__info",
  "leftcol": "form-block-module-scss-module__GkB92a__leftcol",
  "phoneLink": "form-block-module-scss-module__GkB92a__phoneLink",
  "rightcol": "form-block-module-scss-module__GkB92a__rightcol",
  "text": "form-block-module-scss-module__GkB92a__text",
  "title": "form-block-module-scss-module__GkB92a__title",
  "title1": "form-block-module-scss-module__GkB92a__title1",
  "title2": "form-block-module-scss-module__GkB92a__title2",
  "title3": "form-block-module-scss-module__GkB92a__title3",
  "titleServices": "form-block-module-scss-module__GkB92a__titleServices",
});
